export class KeyPairBase {
}
